import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { FiArrowRight } from 'react-icons/fi';

// Configure axios with retry logic for health check
axiosRetry(axios, {
  retries: 3, // Retry up to 3 times
  retryDelay: (retryCount) => retryCount * 1000, // 1s delay between retries
  retryCondition: (error) => true, // Retry on any error
});

const LoadingPage = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Define backend URL with a fallback
  const BACKEND_URL = 'https://minimum-karrah-granday-b79700a0.koyeb.app'; // Replace with your actual Koyeb URL

  useEffect(() => {
    // Log backend URL for debugging
    console.log('Backend URL:', BACKEND_URL);

    const checkServerHealth = async () => {
      try {
        if (!BACKEND_URL || BACKEND_URL.includes('undefined')) {
          throw new Error('Backend URL is not defined. Please set REACT_APP_BACKEND_URL in Vercel.');
        }
        const response = await axios.get(`${BACKEND_URL}/api/health`);
        if (response.status === 200 && response.data.status === 'OK') {
          navigate('/home'); // Redirect to homepage
        }
      } catch (err) {
        setError(
          err.message.includes('Backend URL')
            ? 'Server configuration error. Please contact support.'
            : 'Failed to connect to the server. Please try again later.'
        );
        console.error('Server wake-up error:', err);
      }
    };

    checkServerHealth();
  }, [BACKEND_URL, navigate]);

  // Show error if server fails to wake up
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-dark-900 to-dark-800">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">{error}</h2>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary inline-flex items-center"
          >
            Retry <FiArrowRight className="ml-2" />
          </button>
        </div>
      </div>
    );
  }

  // Loading page with Lottie animation
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-dark-900 to-dark-800">
      <div className="text-center">
        <DotLottieReact
          src="https://lottie.host/c02604f0-6ab4-4a51-b5ac-56679fefd78f/oAJCCQ7XeQ.lottie"
          loop
          autoplay
          style={{ width: '200px', height: '200px', margin: '0 auto' }}
        />
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-4">Please wait a moment while we get things ready!</h2>
        
      </div>
    </div>
  );
};

export default LoadingPage;